module.exports = __webpack_public_path__ + "media/images/projects/15-logo-d80d612207411b74296ecc59c1beefba.png";